const scrollLockClass = 'scroll-lock';
const scrollLockMobileClass = 'scroll-lock--mobile-only';

export const toggleScrollLock = (shouldLock = false, mobileOnly = false) => {
    var htmlElement = document.querySelector('html');

    if (shouldLock) {
        if (mobileOnly) {
            htmlElement.classList.add(scrollLockMobileClass);
        }
        else {
            htmlElement.classList.add(scrollLockClass);
        }
    }
    else {
        htmlElement.classList.remove(scrollLockMobileClass);
        htmlElement.classList.remove(scrollLockClass);
    }
}